import { render, staticRenderFns } from "./EscalaMedica.vue?vue&type=template&id=161bce89&scoped=true"
import script from "./EscalaMedica.vue?vue&type=script&lang=js"
export * from "./EscalaMedica.vue?vue&type=script&lang=js"
import style0 from "./EscalaMedica.vue?vue&type=style&index=0&id=161bce89&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161bce89",
  null
  
)

export default component.exports